/* index.tsx generated by @compiled/babel-plugin v0.38.1 */
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import "./index.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { R500 } from '@atlaskit/theme/colors';
import WarningIcon from '@atlaskit/icon/core/migration/status-warning--warning';
import { Frame } from '../Frame';
import { IconAndTitleLayout } from '../IconAndTitleLayout';
import { AKIconWrapper } from '../Icon';
var errorTitleStyles = null;
export var MediaInlineCardErroredView = /*#__PURE__*/function (_React$Component) {
  function MediaInlineCardErroredView() {
    _classCallCheck(this, MediaInlineCardErroredView);
    return _callSuper(this, MediaInlineCardErroredView, arguments);
  }
  _inherits(MediaInlineCardErroredView, _React$Component);
  return _createClass(MediaInlineCardErroredView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        onClick = _this$props.onClick,
        isSelected = _this$props.isSelected,
        innerRef = _this$props.innerRef,
        _this$props$testId = _this$props.testId,
        testId = _this$props$testId === void 0 ? 'media-inline-card-errored-view' : _this$props$testId,
        icon = _this$props.icon;
      return /*#__PURE__*/React.createElement(Frame, {
        testId: testId,
        innerRef: innerRef,
        onClick: onClick,
        isSelected: isSelected,
        isError: true
      }, /*#__PURE__*/React.createElement(IconAndTitleLayout, {
        icon: icon || /*#__PURE__*/React.createElement(AKIconWrapper, null, /*#__PURE__*/React.createElement(WarningIcon, {
          label: "error",
          LEGACY_size: "small",
          color: "var(--ds-icon-danger, ".concat(R500, ")"),
          size: "small"
        })),
        title: /*#__PURE__*/React.createElement("span", {
          className: ax(["_syaz1ml5"]),
          style: {
            "--_1xw92dq": ix("var(--ds-text-danger, ".concat(R500, ")"))
          }
        }, this.props.message)
      }));
    }
  }]);
}(React.Component);